<template>
  <main>
    <PageHeaderUI title="Ratings" breadcrumb="Ratings  >> Ratings" />
    <div class="flex border-b-2 border-gray-400 pt-2">
      <div class="tab-item" :class="{ active: currentTab == 'MyRatings' }" @click="switchRatings('MyRatings')">
        <p>Rating History</p>
      </div>
      <div class="tab-item" :class="{ active: currentTab == 'DispatcherRatings' }"
        @click="switchRatings('DispatcherRatings')">
        <p>Pending Ratings</p>
      </div>
    </div>
    <main v-loading="loading">
      <component 
      :is="componentDisplay" 
      :ratingResponse="ratingResponse"
      :dispatcherRatingresponse="dispatcherRatingresponse"
      :getRatingTab="getRatingTab"
      />
    </main>
  </main>
</template>

<script>
import PageHeaderUI from "@/components/Ondemand/UI/PageHeaderUI.vue";
import UserRating from "@/components/Ondemand/Rating/UserRating.vue";
import OtherRating from "@/components/Ondemand/Rating/OtherRating.vue";


export default {
  components: {
    PageHeaderUI,
    UserRating,
    OtherRating
  },
  watch: {
    params(val){
      this.getDispacherRating(val)
    }
  },
  computed: {
    params(){
        if(this.currentSubTab == 'alltime') return ''
        return `?timeframe=${this.currentSubTab}`
        },
    componentDisplay() {
      let display
      switch (this.currentTab) {
        case 'MyRatings':
          display = UserRating
          break;

        case 'DispatcherRatings':
          display = OtherRating
          break;

        default:
          display = UserRating
          break;
      }
      return display
    }
  },
  mounted() {
    this.getRating()
    this.getDispacherRating(this.params)
  },
  methods: {
    getRatingTab(tab){
      this.currentSubTab = tab
    },
    async getRating() {
      const response = await this.$_getRating()
      this.ratingResponse = response.data.data
    },
    async getDispacherRating(params) {
      this.loading = true
      const response = await this.$_getDispatcherRating(params)
      this.dispatcherRatingresponse = response.data
      this.loading = false
    },
    switchRatings(val) {
      this.currentTab = val
    }
  },
  data() {
    return {
      reason: "",
      type: 'user',
      currentTab: 'MyRatings',
      ratingResponse: {},
      dispatcherRatingresponse: {},
      currentSubTab: undefined,
      loading: true
    };
  },
};
</script>

<style lang="scss" scoped>
.progress {
  width: 400px;
  height: 40px;

  &>span {
    display: block;
    height: 100%;
    @apply bg-primary-green;
  }
}

.selected_time {
  @apply bg-secondary-yellow rounded px-3 py-2 outline-none
}

.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.25rem 1.5rem;
  font-size: 0.9rem;
  @apply bg-gray-300;

  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #fcc210;
    font-weight: bold;
  }
}
</style>
